var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIconGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 1H2.8C1.80589 1 1 1.80589 1 2.8V17.2C1 18.1941 1.80589 19 2.8 19H6.4C7.39411 19 8.2 18.1941 8.2 17.2V2.8C8.2 1.80589 7.39411 1 6.4 1Z",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2008 1H13.6008C12.6067 1 11.8008 1.80589 11.8008 2.8V6.4C11.8008 7.39411 12.6067 8.2 13.6008 8.2H17.2008C18.1949 8.2 19.0008 7.39411 19.0008 6.4V2.8C19.0008 1.80589 18.1949 1 17.2008 1Z",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2008 11.8008H13.6008C12.6067 11.8008 11.8008 12.6067 11.8008 13.6008V17.2008C11.8008 18.1949 12.6067 19.0008 13.6008 19.0008H17.2008C18.1949 19.0008 19.0008 18.1949 19.0008 17.2008V13.6008C19.0008 12.6067 18.1949 11.8008 17.2008 11.8008Z",
    stroke: "#9B9B9B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconGrey);
export default __webpack_public_path__ + "static/media/dashboard-icon-grey.9a23e62fdc65c61282e48d7f3b2c40e3.svg";
export { ForwardRef as ReactComponent };